module.exports = __webpack_public_path__ + "img/logo1.70b69912.png";